'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _universalConfig = require('roc-package-web-app-react/app/shared/universal-config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAbsoluteRegex = /^https?:\/\/|^\/\//i;
var isAbsolute = function isAbsolute(link) {
    return isAbsoluteRegex.test(link);
};

var _ref = _universalConfig.appConfig || {},
    _ref$site = _ref.site;

_ref$site = _ref$site === undefined ? {} : _ref$site;
var _ref$site$baseUrl = _ref$site.baseUrl,
    baseUrl = _ref$site$baseUrl === undefined ? '/' : _ref$site$baseUrl;

var toRelative = function toRelative(link) {
    return link && link.replace(new RegExp('^' + baseUrl + '/*'), '/');
};

/* eslint-disable padded-blocks */
var InternalLink = function InternalLink(_ref2) {
    var theme = _ref2.theme,
        link = _ref2.link,
        rel = _ref2.rel,
        target = _ref2.target,
        children = _ref2.children,
        enableSinglePage = _ref2.enableSinglePage,
        makeRelative = _ref2.makeRelative,
        testTagDefault = _ref2.testTagDefault,
        testTagNoLink = _ref2.testTagNoLink,
        testTagSinglePage = _ref2.testTagSinglePage,
        rest = (0, _objectWithoutProperties3.default)(_ref2, ['theme', 'link', 'rel', 'target', 'children', 'enableSinglePage', 'makeRelative', 'testTagDefault', 'testTagNoLink', 'testTagSinglePage']);

    /* eslint-enable padded-blocks */

    var linkTo = makeRelative(link);
    var isLinkAbsolute = isAbsolute(linkTo);

    if (!link) {
        return _react2.default.createElement(
            'div',
            { className: theme.children, 'data-test-tag': testTagNoLink },
            children
        );
    }

    if (enableSinglePage && !isLinkAbsolute) {
        return _react2.default.createElement(
            _reactRouter.Link,
            (0, _extends3.default)({
                className: theme.relative, 'data-test-tag': testTagSinglePage,
                to: linkTo, rel: rel, target: target }, rest),
            children
        );
    }

    return _react2.default.createElement(
        'a',
        (0, _extends3.default)({
            className: isLinkAbsolute ? theme.absolute : theme.relative,
            'data-test-tag': testTagDefault,
            href: linkTo, rel: rel, target: target }, rest),
        children
    );
};

InternalLink.propTypes = {
    theme: _propTypes2.default.shape({
        children: _propTypes2.default.string,
        relative: _propTypes2.default.string,
        absolute: _propTypes2.default.string
    }),
    link: _propTypes2.default.string,
    rel: _propTypes2.default.string,
    target: _propTypes2.default.string,
    children: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    enableSinglePage: _propTypes2.default.bool,
    makeRelative: _propTypes2.default.func,
    testTagDefault: _propTypes2.default.string,
    testTagNoLink: _propTypes2.default.string,
    testTagSinglePage: _propTypes2.default.string
};

InternalLink.defaultProps = {
    theme: {},
    link: '',
    rel: '',
    target: '',
    enableSinglePage: false,
    makeRelative: toRelative,
    testTagDefault: '@spp/ui-internal-link',
    testTagNoLink: '@spp/ui-internal-link:no-link',
    testTagSinglePage: '@spp/ui-internal-link:single-page-link'
};

exports.default = InternalLink;
//# sourceMappingURL=InternalLink.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-internal-link/lib/cjs/InternalLink.js
 ** module id = 662
 ** module chunks = 1
 **/